import { useRef, useEffect } from "react";
import styled from "styled-components";
import { ContactUsGetInTouch } from "./ContactUsGetInTouch";
import { ContactUsHeroSection } from "./ContactUsHeroSection";
import { ContactUsAdditionalContact } from "./ContactUsAdditionalContact";
import { ContactUsJoinTeam } from "./ContactUsJoinTeam";
import { MainFooter } from "../../Footer/MainFooter";
import { ContactUsPrimaryContact } from "./ContactUsPrimaryContact";

export function ContactUsNormal({ pageContent = {}, desktop = false }) {
	const refMessageForm = useRef(null);
	const refCareer = useRef(null);
	const refCareerOrigin = useRef(null);
	const refPrimaryContact = useRef(null);
	const { content = {} } = pageContent;

	const handleScrollToMessageUs = () => {
		if (refMessageForm.current) {
			const y = refMessageForm.current.getBoundingClientRect().top - 200;
			window.scrollTo({ top: y, behavior: "smooth" });
		}
	};

	useEffect(() => {
		if (window.location.hash && window.location.hash === "#career") {
			setTimeout(
				() =>
					refCareer.current?.scrollIntoView({
						behavior: "smooth",
					}),
				0,
			);
		}

		if (window.location.hash && window.location.hash === "#contact-us-get-in-touch") {
			handleScrollToMessageUs();
		}
	}, []);

	return (
		<Container>
			<ContactUsHeroSection
				banner={content?.banner}
				onPressMessageUs={handleScrollToMessageUs}
				onPressContactInfo={() => {
					refPrimaryContact.current?.scrollIntoView({
						behavior: "smooth",
					});
				}}
				onPressEmployment={() => {
					refCareerOrigin.current?.scrollIntoView({
						behavior: "smooth",
					});
				}}
				desktop={desktop}
			/>
			<BodyContainer ref={refPrimaryContact}>
				<ContactUsPrimaryContact primary_contact={content?.primary_contact} />
			</BodyContainer>
			<BodyExperienceContainer>
				<LayoutOverlay>
					<BodyContainer>
						<ContactUsAdditionalContact additional_contact={content?.additional_contact} />
					</BodyContainer>
				</LayoutOverlay>
			</BodyExperienceContainer>
			<BodyContainer ref={refCareerOrigin}>
				<ContactUsJoinTeam
					joining_our_team={content?.joining_our_team}
					available_positions={content?.available_positions}
					refCareer={refCareer}
				/>
			</BodyContainer>
			<BodyContainer style={{ paddingBottom: "40px" }}>
				<ContactUsGetInTouch ref={refMessageForm} get_in_touch_with_us={content?.get_in_touch_with_us} />
			</BodyContainer>

			<footer style={{ width: "100%" }}>
				<MainFooter />
			</footer>
		</Container>
	);
}

const LayoutOverlay = styled.div`
	width: 100%;
	height: 100%;
	background: rgba(249, 249, 249, 0);
	display: flex;
	justify-content: center;
`;
const BodyExperienceContainer = styled.div`
	width: 100%;
	background-image: url("/images/private-jet-travel/private-jet-travel-mask.png");
	display: flex;
	justify-content: center;
	margin-top: 120px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	@media (max-width: 991px) {
		margin-top: 80px;
		background-image: url("/images/private-jet-travel/private-jet-travel-mask-mobile.png");
	}
	@media (max-width: 767px) {
		margin-top: 60px;
		background-image: url("/images/private-jet-travel/private-jet-travel-mask-mobile.png");
	}
	@media (max-width: 576px) {
		margin-top: 40px;
		background-image: url("/images/private-jet-travel/private-jet-travel-mask-mobile.png");
	}
`;
const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
const BodyContainer = styled.div`
	max-width: 100vw;
	padding: 84px 136px;
	width: 100%;
	@media (max-width: 991px) {
		padding: 90px 80px 0px 80px;
	}
	@media (max-width: 767px) {
		padding: 60px 32px 00px 32px;
	}
	@media (max-width: 575px) {
		padding: 40px 20px 0px 20px;
	}
`;
